<latam-it-progress-bar
[amountLabel]="progressBar.amountLabel"
[currentLabel]="progressBar.currentLabel"
[amountBar]="progressBar.amountBar"
[currentBar]="progressBar.currentBar"
[labelName]="progressBar.labelName">
</latam-it-progress-bar>
